import * as React from "react";
import { Settings } from "react-slick";
import styled from "styled-components";
import { routeConfig } from "../../../../config/language/ja-JP/presentation/route_text";
import {
  ConstBreakPoint,
  ConstCalc,
} from "../../../../config/styles_const/styles_const";
import { ClientBookmark } from "../../../../domain/model/client_bookmark";
import { Company } from "../../../../domain/model/company";
import { Customer } from "../../../../domain/model/customer";
import { JobCareer } from "../../../../domain/model/job_career";
import { PastCaseProject } from "../../../../domain/model/past_case_project";
import { SearchHighlight } from "../../../../domain/model/search_highlight";
import { OccupationSkillTag } from "../../../../domain/model/skill_tag";
import { TJobCareerWithCustomerID } from "../../../../domain/repository/job_career_repository";
import SlideNextArrow from "../../../common/atom/slider_arrow/slide_next_arrow";
import SlidePrevArrow from "../../../common/atom/slider_arrow/slide_prev_arrow";
import PageWrapper from "../../../common/atom/wrapper/page_wrapper";
import Breadcrumbs from "../../../common/molecular/breadcrumbs/breadcrumbs";
import Progress from "../../../common/organism/progress";
import { TBreadcrumbItem } from "../../../type/common";
import ClientScoutCustomerMainScoutFirstForm from "./client_scout_customer_first/client_scout_customer_main_scout_first_form";

// breackpoint は調整必要
const settings: Settings = {
  className: "slider",
  dots: false,
  infinite: false,
  centerMode: false,
  swipeToSlide: true,
  variableWidth: true,
  arrows: true,
  prevArrow: <SlidePrevArrow />,
  nextArrow: <SlideNextArrow />,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },

    {
      breakpoint: 450,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

interface IProps {
  isLoading: boolean;
  customer: Customer | null;
  sameOccupationCustomers: Customer[];
  jobCareersWithSameOccupationCustomerID: TJobCareerWithCustomerID[];
  company: Company | null;
  jobCareers: JobCareer[];
  highlights: SearchHighlight[];
  pastCaseProjects: PastCaseProject[];
  clientBookmarks: ClientBookmark[];
  occupationSkillTags: OccupationSkillTag[];
  isClientBookmark: boolean;
  handleNextStep: (values: any) => void;
  handleCreateClientBookmark: (event: any) => void;
  handleDeleteClientBookmark: (event: any) => void;
}

const ClientScoutCustomerFirstComponent: React.FC<IProps> = (props) => {
  const {
    isLoading,
    customer,
    sameOccupationCustomers,
    jobCareersWithSameOccupationCustomerID,
    company,
    jobCareers,
    highlights,
    pastCaseProjects,
    clientBookmarks,
    isClientBookmark,
    handleNextStep,
    handleCreateClientBookmark,
    handleDeleteClientBookmark,
    occupationSkillTags,
  } = props;

  const params = {
    initialValues: {
      customer,
    },
    isClientBookmark,
    company,
    jobCareers,
    highlights,
    pastCaseProjects,
    handleCreateClientBookmark,
    handleDeleteClientBookmark,
    occupationSkillTags,
  };

  const breadcrumbItems: TBreadcrumbItem[] = [
    routeConfig.clientRoot,
    { text: `プロフィール` },
  ];

  if (isLoading) {
    return <Progress canAnimation={false} />;
  }

  return (
    <React.Fragment>
      <PageWrapper>
        <Breadcrumbs breadcrumbItems={breadcrumbItems} />

        <ClientScoutCustomerMainScoutFirstForm
          {...params}
          onSubmit={handleNextStep}
          enableReinitialize={true}
        />
        {/* <SubTitleWrapper>
                    <HeadlineSmall >類似エキスパート</HeadlineSmall>
                </SubTitleWrapper>

                <SliderWrapper>
                    <Slider {...settings}>
                        {sameOccupationCustomers.map((sameOccupationCustomer) => {
                            const jobCareerWithCustomerID = jobCareersWithSameOccupationCustomerID.find((_jobCareerWithCustomerID) => {
                                return _jobCareerWithCustomerID.customerID === sameOccupationCustomer.id
                            })
                            const sameOccupationCustomerJobCareers = jobCareerWithCustomerID ? jobCareerWithCustomerID.jobCareers : []
                            const isBookmarked: boolean = clientBookmarks.some((clientBookmark:ClientBookmark) => {
                                return clientBookmark.customerID === sameOccupationCustomer.id
                            });

                            return (
                                <SlideCustomerWrapper key={sameOccupationCustomer.id} style={{width: 200}}>
                                    <SlideCustomerCard
                                        customer={sameOccupationCustomer}
                                        jobCareers={sameOccupationCustomerJobCareers}
                                        isBookmarked={isBookmarked}
                                    />
                                </SlideCustomerWrapper>
                            )
                        })}
                    </Slider>
                </SliderWrapper> */}
      </PageWrapper>
    </React.Fragment>
  );
};

export default ClientScoutCustomerFirstComponent;

const SubTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 15px;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    margin-bottom: 25px;
  }
`;

const SliderWrapper = styled.div`
  margin-bottom: 40px;

  // react-slickの横幅の計算がうまく働いていないのでここで決めている感じ
  max-width: ${ConstCalc.CustomerSlideMaxWidthSp};
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    margin-bottom: 50px;
    max-width: ${ConstCalc.CustomerSlideMaxWidthTablet};
  }
  @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
    max-width: ${ConstCalc.CustomerSlideMaxWidthPc};
  }

  // 一部で縦の大きさが変動していたため固定する
  & .slick-slider {
    height: 334px;
  }
`;

const SlideCustomerWrapper = styled.div`
  padding: 5px 15px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/scout_customer/client_scout_customer_first.tsx